import appStore from 'store';
import appApi from './AppHomePage/api';

const store = {
    namespaced: true,
    state: {
        appComponentList: [],
        kingKongList: [],
        manageMoneyList: [],
        areaType: 1,
        appKingKongLang: 1,
        focusKingKongLang: 1
    },
    mutations: {
        setAppComponentList(state, payload) {
            state.appComponentList = payload;
        },
        setKingKongList(state, payload) {
            state.kingKongList = payload;
        },
        setManageMoneyList(state, payload) {
            state.manageMoneyList = payload;
        },
        setAreaType(state, payload) {
            state.areaType = payload;
        },
        setAppKingKongLang(state, payload) {
            state.appKingKongLang = payload;
        },
        setFocusKingKongLang(state, payload) {
            state.focusKingKongLang = payload;
        }
    },
    actions: {
        selectAppComponent({commit}) {
            appApi.componentList().then(response => {
                commit('setAppComponentList', response.data);
            })
        },

        selectKingKong({commit}, data) {
            appApi.kingKongList(data).then(response => {
                commit('setKingKongList', response.data);
            })
        },

        selectManageMoney({commit}) {
            appApi.financialManageList().then(response => {
                commit('setManageMoneyList', response.data);
            })
        },

        selectAreaType({commit}, data) {
            commit('setAreaType', data);
        },

        changeAppKingKongLang({commit}, data) {
            commit('setAppKingKongLang', data);
        },

        changeFocusKingKongLang({commit}, data) {
            commit('setFocusKingKongLang', data);
        }
    }
}

appStore.registerModule('PortalManage', store);
